
import { currencyFormatter, currencyFormatterNoDecimals } from './numbers.js';


/**
 * a utility function for formatting currency figures. At the moment, this is
 * always USD
 */
export default function(value, includeDecimals = true) {
  if (includeDecimals) {
    return currencyFormatter.format(value);
  } else {
    return currencyFormatterNoDecimals.format(value);
  }
}

